module.exports = __webpack_public_path__ + "img/6.10.pH.5d4fbd82.png";